import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ScrollX from 'gatsby-core-theme/src/hooks/scroll-x';
import keygen from '~helpers/keygen';
import GridItem from '../../../../../components/molecules/toplist/grid-item';
import styles from './grid.module.scss';
import Buttons from './buttons';

const Grid = ({ toplist, pageTemplate, module, pagePath, modulePosition }) => {
  const container = useRef(null);

  const [scrollX, setScrollX] = useState(0);
  const [scrollEnd, setScrollEnd] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const updateButtons = (shift) => {
    setScrollEnd(
      Math.floor(container.current.scrollWidth - (container.current.scrollLeft + shift)) <=
        container.current.offsetWidth
    );
  };

  const scroll = (shift) => {
    container.current.scrollTo({
      left: container.current.scrollLeft + shift,
      behavior: 'smooth',
    });
    updateButtons(shift);
    setScrollX(scrollX + shift);
  };

  const onStopScrolling = () => {
    setScrollX(container.current.scrollLeft);
    updateButtons(0);
  };

  const onScroll = (scrollLeft) => {
    updateButtons(0);
    setScrollX(scrollLeft);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButtons(container.current.scrollWidth > container.current.offsetWidth);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ScrollX refTag={container} scroll stopScrolling={() => onStopScrolling()} onScroll={onScroll}>
      <div ref={container} className={styles.container}>
        {toplist.items?.map((item, index) => (
          <GridItem
            pagePath={pagePath}
            item={item}
            tracker={toplist.tracker}
            pageTemplate={pageTemplate}
            key={keygen()}
            oneliner={toplist.one_liner}
            index={index}
            module={module}
            itemPosition={index + 1}
            modulePosition={modulePosition}
          />
        ))}
        {showButtons && <Buttons scroll={scroll} scrollX={scrollX} scrollEnd={scrollEnd} />}
      </div>
    </ScrollX>
  );
};

Grid.propTypes = {
  toplist: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      })
    ),
    tracker: PropTypes.string,
    one_liner: PropTypes.string,
  }),
  pageTemplate: PropTypes.string,
  module: PropTypes.string,
  pagePath: PropTypes.string,
  modulePosition: PropTypes.number,
};

export default Grid;
